import {
  borderCss,
  boxShadowCss,
  mobileBorderCss,
  mobileBoxShadowCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import styled, { css } from 'styled-components'

type VideoContainerUiProps = BorderEntityInterface & {
  boxShadow?: string
  mobileBoxShadow?: string
}

export const VideoContainerUi = styled.div<VideoContainerUiProps>`
  overflow: hidden;
  ${borderCss};
  ${boxShadowCss};

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBorderCss};
      ${mobileBoxShadowCss};
    `}
  ${p => p.theme.phone} {
    ${mobileBorderCss};
    ${mobileBoxShadowCss};
  }
`
